import { mutate } from 'swr';

/**
 * SWR 캐시 무효화 유틸리티
 *
 * 사용 사례:
 * 1. 주문 실패 시 상품 상태 변경 가능성으로 인한 캐시 무효화
 * 2. 상품 정보 업데이트 후 즉시 반영 필요 시
 * 3. 품절/재입고 상태 변경 즉시 반영 필요 시
 *
 * 장점:
 * - SWR의 기존 캐싱 메커니즘 유지
 * - 필요한 시점에만 선택적 캐시 무효화
 * - 메모리 효율적 (snapshot 구독 대비)
 * - 비용 효율적 (변경 가능성이 높은 시점에만 무효화)
 */

/**
 * 특정 상품의 SWR 캐시를 무효화합니다.
 * @param productId 상품 ID
 */
export const invalidateProductCache = (productId: string) => {
  console.log(`[SWR Cache] 상품 캐시 무효화: ${productId}`);

  // useImmutableProductById 캐시 무효화
  // SWR Immutable은 기본적으로 revalidate하지 않지만, 강제로 무효화 가능
  mutate(productId, undefined, { revalidate: true });
};

/**
 * 여러 상품의 SWR 캐시를 한번에 무효화합니다.
 * @param productIds 상품 ID 배열
 */
export const invalidateMultipleProductCaches = (productIds: string[]) => {
  console.log(`[SWR Cache] 여러 상품 캐시 무효화: ${productIds.length}개`);

  productIds.forEach((productId) => {
    invalidateProductCache(productId);
  });
};

/**
 * 주문 실패 시 장바구니 상품들의 캐시를 무효화합니다.
 * 주문 버튼 클릭 시 상품 상태가 변경되었을 가능성이 높기 때문
 * @param productIds 장바구니 상품 ID 배열
 */
export const invalidateCartProductCaches = (productIds: string[]) => {
  console.log(`[SWR Cache] 장바구니 상품 캐시 무효화: ${productIds.length}개`);

  // 품절이나 상태 변경 가능성이 높은 상품들의 캐시를 무효화
  invalidateMultipleProductCaches(productIds);
};
